<template>
  <div class="work_add_box">
    <helpHeader></helpHeader>
    <div class="work_add_content">
      <div class="content-header">
        <div class="left">新增工单</div>
        <div class="right">
          <Button style="margin-right: 15px" @click="$router.back()"
            >取消</Button
          >
          <Button type="primary" @click="save">提交</Button>
        </div>
        <div class="bottom"></div>
      </div>
      <Form
        :rules="rule"
        ref="form"
        :label-colon="true"
        :model="data"
        :label-width="90"
      >
        <div class="work_add_customer">
          <FormItem label="工单类型" prop="cat">
            <Select
              v-model="data.cat"
              style="width: 300px"
              placeholder="请选择工单类型"
            >
              <Option value="0">功能需求</Option>
              <Option value="1">后台使用问题</Option>
              <Option value="2">疑问解答</Option>
              <Option value="3">其它问题</Option>
            </Select>
          </FormItem>
          <FormItem label="紧急程度" prop="level">
            <RadioGroup v-model="data.level" style="width: 300px">
              <Radio label="0">一般</Radio>
              <Radio label="1">重要</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="问题描述" prop="describe">
            <Input
              style="width: 600px"
              v-model="data.describe"
              type="textarea"
              :rows="5"
              placeholder="请详细描述你的问题，10-1000个字符"
            />
          </FormItem>
          <FormItem label="手机号码" prop="phone">
            <Input
              style="width: 300px"
              v-model="data.phone"
              maxlength="11"
              placeholder="请正确填写联系手机号码"
            />
            <div class="tips">
              紧急情况时，工作人员将联系你，请正确填写手机号码
            </div>
          </FormItem>
          <FormItem label="邮箱地址" prop="email">
            <Input
              style="width: 300px"
              type="email"
              v-model="data.email"
              placeholder="请正确填写联系邮箱地址"
            />
          </FormItem>
          <FormItem label="附件">
            <div style="width:100%">
              <div class="up_box">
                <Button icon="md-add"
                  >添加附件</Button
                >
                <input
                  type="file"
                  class="file_input"
                  @change="uploadChangeOrder"
                />
              </div>
              <p
                class="filt-tag"
                v-for="(item, index) in fileList"
                :key="index"
              >
                <Tag closable @on-close="deleteFiles(index)"> {{ item }}</Tag>
              </p>
              <p class="tips">
                可上传<span style="color: #f2935e">5个附件</span>
              </p>
              <p class="tips">
                每个附件大小不得超过8M。附件支持的格式有：'jpg','jpeg','bmp','png',<br />'gif','txt','rar','zip','doc','docx','ini','conf','eml','xlsx','xls','pdf'
              </p>
            </div>
          </FormItem>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import helpHeader from "@/components/help-header";
import { mapActions, mapGetters } from "vuex";
import { uploadOSS } from "@/libs/util";
import config from "../../../config/index";
import OSS from "ali-oss";
export default {
  components: {
    helpHeader,
  },
  data() {
    return {
      uploadUrl: config.baseUrl.pro,
      data: {
        cat: "",
        level: 0,
        describe: "",
        phone: "",
        email: "",
        enclosure: [],
      },
      fileList:[],
      rule: {
        cat: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: "select",
          },
        ],
        level: [
          {
            required: true,
            message: "请选择紧急程度",
            trigger: "change",
          },
        ],
        describe: [
          {
            required: true,
            message: "请填写问题描述",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "请填写手机号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请填写邮箱地址",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["CreateWorkOrder"]),

    save() {
      let data = this.data;
      data.enclosure = JSON.stringify(data.enclosure)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.CreateWorkOrder(data).then((res) => {
            this.$Message[res.status ? "success" : "error"](res.msg);
            if (!res.status) return false;
            this.$router.back();
          });
        }
      });
    },
    deleteFiles(index) {
      this.fileList.splice(index, 1);
      this.data.enclosure.splice(index, 1);
    },
    uploadChangeOrder(e) {
      console.log("上传的文件", e);
      let file = e.target.files[0];
      if (file.size > 5242880) {
        this.$Notice.warning({
          title: "上传失败",
          desc: `文件”${file.name}“过大`,
        });
        return false;
      }
      this.$Spin.show();
      let date = this.$moment(new Date(), "YYYY-MM-DD");
      let src = `shop/${this.current_user.shop_id}/work/shop_id-${this.current_user.shop_id}/${date}/files/`;
      uploadOSS(src, file).then((oss) => {
        this.$Spin.hide();
      let url = {
          name: file.name,
          url: oss.url,
        };
        this.data.enclosure.push(url);
        this.fileList.push(file.name);
      });
    },
  },
  computed: mapGetters({ current_user: "current_user" }),
};
</script>
<style lang='less' >
@import "./index.less";
</style>
